export const isSuperUser = (user) => {
    return user?.tipo_usuario === "" || user?.is_superuser;
};

export const getUserEmail = (user) => {
    return user?.email;
};
